import Account from 'components/Controller/Account'
import { Navigate } from 'react-router-dom'
import CreateTeacher from './CreateTeacher'
import Teacher from './Teacher'
import UpdateTeacher from './UpdateTeacher'
const Teachers = [
	{
		path: 'account',
		element: <Navigate to='account/teachers' />,
	},
	{
		path: 'account/teachers',
		element: (
			<Account>
				<Teacher />
			</Account>
		),
	},
	{
		path: 'account/teachers/create',
		element: (
			<Account>
				<CreateTeacher />
			</Account>
		),
	},
	{
		path: 'account/teachers/update/:id',
		element: (
			<Account>
				<UpdateTeacher />
			</Account>
		),
	},
]
export default Teachers
